import { render, staticRenderFns } from "./ProfileRow.vue?vue&type=template&id=136f26ff&"
import script from "./ProfileRow.vue?vue&type=script&lang=js&"
export * from "./ProfileRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports